import styled from "styled-components";

export const Container = styled("div")`
  display: inline-block;
  width: 100%;
  padding: 10px 5px;
`;

export const StyledInput = styled("input")`
  font-size: 12px;
  background-color:#e6e6e6;
  font-family: 'IRANSansWeb';
  text-align:right;
  height: 55px;
`;
